<template>
	<input ref="commonNumber" type="text" :value="fmtVal" :maxlength="frmMaxLength" @input="onInput" @blur="onBlur" :style="frmStyle" />
</template>

<script>

export default {
    name: 'CommonNumber',

    props : {
        value: {
        	
        },
        options : {
            required: true
        },
        
        decimal	:	{
			type		:	String  ,
			required	:	false
		},
    },

    data() {
        return {
          val: '',
          point : 99
        }
    },
    
    watch: {
      value(newVal, oldVal) {
        this.val = newVal;
      }
    },
    
    
    computed: {    	
      // 값처리 	
      fmtVal() {
    	  return this.val;
      },
      
      // Max Length
      frmMaxLength() {
          return this.options.maxlength;
      },
      // Style 적용
      frmStyle(){
    	  return this.options.style;
      }
    },

    created: function() {
    	
    
		this.val = this.value;		
		

  		if(typeof(this.decimal) != 'undefined') {  			
			this.point = this.decimal;
		}
  		
		
	},

    methods: {
    	
      onInput: function(e) { 
    	    
        this.val = e.target.value.replace(/,/g, '');
        
	    this.$emit('input', this.val);
	    
	    if(e.target.value.length == 1 ){
	    	this.numberWithCommas(e.target.value);
	    }
        
      },
      
      onBlur: function(e) { 
     	 
    	if(this.decimal == "0") {    	  
        	this.val = e.target.value.replace(/[^0-9\\-]/g, "");
    	}else{
    		this.val = e.target.value.replace(/[^0-9\\.\\-]/g, "");
    	}
    	
   	    if( e.target.value.lastIndexOf(".") > 0) {    //중간에 -가 있다면 replace             
   	    	this.val =  e.target.value.substring(0,  e.target.value.indexOf(".") + 1)  +  e.target.value.substring( e.target.value.indexOf(".") + 1).replace(/[.]/gi,'');                     
        }
   	 
     	if( e.target.value.lastIndexOf("-") > 0) {    //중간에 -가 있다면 replace
            if( e.target.value.indexOf("-") == 0){    //음수라면 replace 후 - 붙여준다.
               this.val = "-" +  e.target.value.replace(/[-]/gi,'');
            }else{
               this.val =  e.target.value.replace(/[-]/gi,'');
            }         
        }
    	 
         
 	    this.$emit('input', this.val)
         
       },
      
      
      numberWithCommas(n) {    	  
    	  
    	   
    	 if( n == 'undefined' || n == null || n == '') {    
      		return n;
      	 }
    	   
    	 
    	 if(n.toString() === "0") {    
    		 this.val = 0;
      		 return 0;
      	 }
    	 
    	
    	 let _value = n.toString();
    	 let v      = '';
    	 let rtnValue = '';
    	     	 
    	 
    	 // 숫자 이외에 제거
    	 
    	 if(this.point == "0") {    	    		 
    		_value = _value.replace(/[^0-9]/g, "");
    	 }else{
    	 	_value = _value.replace(/[^0-9\\.\\-]/g, "");
    	 }
    	 
    	 
    	 if(_value.indexOf("0.") === -1 ) {
    		 //숫자 앞자리 제거
	    	 _value = _value.replace(/^0+/g,"");	    	 
    	 }
    	 
    	 if(_value.lastIndexOf(".") > 0) {    //중간에 -가 있다면 replace             
             _value = _value.substring(0, _value.indexOf(".") + 1)  + _value.substring(_value.indexOf(".") + 1).replace(/[.]/gi,'');                     
         }
    	 
    	 if(_value.lastIndexOf("-") > 0) {    //중간에 -가 있다면 replace
             if(_value.indexOf("-") == 0){    //음수라면 replace 후 - 붙여준다.
            	 _value = "-" + _value.replace(/[-]/gi,'');
             }else{
            	 _value = _value.replace(/[-]/gi,'');
             }         
         }
           
	      
    	 let reg = /(^[+-]?\d+)(\d{3})/;
     	 let ret = (_value + '');
  
     	 while (reg.test(ret)) ret = ret.replace(reg, '$1' + ',' + '$2');
     	 
     	 
     	 if(this.point != 99 ) {
     		 
     		if(ret.indexOf(".") > 0 ) {
     			let v = ret.substring(ret.indexOf(".") + 1);
     			
     			if(v.length > this.point ) {
     				rtnValue = ret.substring(0,ret.indexOf(".") + 1 + Number(this.point));
     				
     				
     				this.val = rtnValue;
     				
     				return rtnValue;
     			}
     		}
     	 }
     	 
 		 return ret;		
 		
	  },

	  focus(){
		  this.$refs.commonNumber.focus();
	  }

    }
}
</script>